import { render } from "./LegalNotice.vue?vue&type=template&id=26d32d24&scoped=true"
import script from "./LegalNotice.vue?vue&type=script&lang=js"
export * from "./LegalNotice.vue?vue&type=script&lang=js"

import "./LegalNotice.vue?vue&type=style&index=0&id=26d32d24&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26d32d24"]])

export default __exports__